import React from 'react'
import { Pagination, Typography, Row, Col, theme } from 'antd'

const { Text } = Typography

const NavigationBar = ({
  currentPage = 1,
  totalPages = 355,
  totalResults = 7081,
  resultsPerPage = 20,
  onPageChange,
  searchType = 'general_practitioner'
}) => {
  const startResult = (currentPage - 1) * resultsPerPage + 1
  const endResult = Math.min(currentPage * resultsPerPage, totalResults)
  const { token } = theme.useToken()

  // Get display name for search type
  const getSearchTypeDisplayName = (type) => {
    const typeMap = {
      general_practitioner: 'General Practitioners',
      cardiologist: 'Cardiologists',
      dermatologist: 'Dermatologists',
      neurologist: 'Neurologists',
      psychiatrist: 'Psychiatrists',
      gynaecologist: 'Gynaecologists',
      dentist: 'Dentists',
      virtual_consultation: 'Virtual Consultations',
      vitality_health_check: 'Health Check Providers'
    }
    return typeMap[type] || 'Healthcare Providers'
  }

  const handlePageChange = (page, pageSize) => {
    onPageChange?.(page)
  }

  return (
    <div
      style={{
        background: '#e5e7eb',
        padding: '16px 20px',
        borderBottom: '1px solid #d1d5db'
      }}
    >
      <Row justify='space-between' align='middle' wrap>
        <Col xs={24} sm={12} md={8}>
          <Text
            style={{
              fontSize: '14px',
              color: '#374151',
              fontWeight: '500'
            }}
          >
            Showing {startResult} - {endResult} of {totalResults} {getSearchTypeDisplayName(searchType)}
          </Text>
        </Col>

        <Col
          xs={24}
          sm={12}
          md={16}
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: { xs: '12px', sm: '0' }
          }}
        >
          <Pagination
            current={currentPage}
            total={totalResults}
            pageSize={resultsPerPage}
            showSizeChanger={false}
            showQuickJumper={false}
            onChange={handlePageChange}
            showTotal={(total, range) => `Page ${currentPage} of ${totalPages}`}
            style={{
              '.ant-pagination-item-active': {
                backgroundColor: token.colorPrimary,
                borderColor: token.colorPrimary
              }
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default NavigationBar
